// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3d5Ly","header":"ClearentDisclaimer_header__3BKM7","inner":"ClearentDisclaimer_inner__wUJWU"};